
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
import { emitter, NotificationType } from "@/composables/emitter";
export default Vue.extend({
  data() {
    return {
      loadingPrebuiltForms: false,
      updateInProgress: false,
      prebuiltFormsList: [] as any[],
      hasLoadedOnce: false,
      editingFormId: null as string | null,
    };
  },
  methods: {
    async getAllPrebuiltForms() {
      try {
        this.loadingPrebuiltForms = true;
        const { data } = await FormsAndSurveyServices.getPrebuiltFormsList({
          locationId: config.prebuiltFormLocation,
        });
        this.prebuiltFormsList = (data.themes || data.prebuiltForms || []).map((form: any) => ({
          ...form,
          editCategory: form.category || '',
          editPriority: form.priority || 1
        }));
        this.hasLoadedOnce = true;
        this.loadingPrebuiltForms = false;
      } catch (error) {
        console.log(error);
        this.prebuiltFormsList = [];
        this.hasLoadedOnce = true;
        this.loadingPrebuiltForms = false;
      }
    },
    async updatePrebuiltForm(form: any) {
      try {
        this.updateInProgress = true;
        this.editingFormId = form._id;
        await FormsAndSurveyServices.updateThemes('forms', form._id, {
          category: form.editCategory,
          priority: form.editPriority
        });
        // Update the original values after successful update
        form.category = form.editCategory;
        form.priority = form.editPriority;
        this.updateInProgress = false;
        this.editingFormId = null;
        emitter.$emit("notification", {
          title: "Success",
          message: "Prebuilt form updated successfully!",
          type: NotificationType.INFO,
        });
        // Refetch the prebuilt forms to ensure data is in sync
        await this.getAllPrebuiltForms();
      } catch (error: any) {
        console.error(error);
        this.updateInProgress = false;
        this.editingFormId = null;
        emitter.$emit("notification", {
          title: "Update Failed",
          message: error.response?.data?.message || "Failed to update prebuilt form",
          type: NotificationType.ERROR,
        });
      }
    },
    isUpdateDisabled(form: any): boolean {
      return this.updateInProgress || 
             (form.category === form.editCategory && form.priority === form.editPriority) ||
             !form.editCategory;
    }
  },
});
